export default {
  VAlert: {
    density: 'comfortable',
    elevation: 0,
    rounded:'lg'
  },
  VTab: {
    elevation: 0,
    rounded:'lg'
  },
  VAvatar: {
    // ℹ️ Remove after next release
    variant: 'outlined',
  },
  VBadge: {
    // set v-badge default color to primary
    color: 'primary',
  },
  VBtn: {
    color: 'primary',
    variant: 'outlined',
    rounded: 'lg',
    elevation: 6,
  },
  VChip: {
    size: 'small',
    rounded: 'xl',
    color: 'main-primary'
  },

  VMenu: {
    VList: {
      density: 'compact',
    },
  },
  VPagination: {
    activeColor: 'error',
    density: 'comfortable',
    variant: 'tonal',
  },
  VTabs: {
    // set v-tabs default color to primary
    color: 'primary',
    density: 'comfortable',
    elevation: 0,
    VTab: {
      elevation: 0,
      rounded:'lg'
    }
  },
  VTooltip: {
    // set v-tooltip default location to top
    location: 'top',
  },
  VList: {
    VListItem: {
      activeColor: 'primary',
    },
  },
  VCheckbox: {
    color: 'primary',
    density: 'comfortable',
    hideDetails: 'auto',
  },
  VRadioGroup: {
    color: 'primary',
    density: 'comfortable',
    hideDetails: 'auto',
  },
  VRadio: {
    density: 'comfortable',
    hideDetails: 'auto',
  },
  VSelect: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    hideDetails: 'auto',
    bgColor: 'var(--v-textfields-bg)',
    rounded: 'lg',
  },
  VRangeSlider: {
    // set v-range-slider default color to primary
    color: 'primary',
    thumbSize: 14,
    density: 'comfortable',
    thumbLabel: true,
    hideDetails: 'auto',
  },
  VRating: {
    // set v-rating default color to primary
    color: 'warning',
  },
  VProgressCircular: {
    // set v-progress-circular default color to primary
    color: 'primary',
  },
  VSlider: {
    // set v-slider default color to primary
    color: 'primary',
    hideDetails: 'auto',
    thumbSize: 14,
  },
  VTextField: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    hideDetails: 'auto',
    bgColor: 'var(--v-textfields-bg)',
    rounded:'lg',
  },
  VAutocomplete: {
    variant: 'outlined',
    color: 'primary',
    density: 'compact',
    hideDetails: 'auto',
    bgColor: 'var(--v-textfields-bg)',
    rounded:'lg'
  },
  VCombobox: {
    variant: 'outlined',
    color: 'primary',
    hideDetails: 'auto',
    bgColor: 'var(--v-textfields-bg)',
    rounded:'lg'
  },
  VFileInput: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    hideDetails: 'auto',
    bgColor: 'var(--v-textfields-bg)',
    rounded: 'lg',
  },
  VTextarea: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary',
    hideDetails: 'auto',
    rounded: 'lg',
    bgColor: 'var(--v-textfields-bg)'

  },
  VSwitch: {
    color: 'error',
    hideDetails: 'auto',
  },
  VTimeline: {
    lineThickness: 1,
  },
  VIcon: {
    size: 24,
    color: 'icons-color'
  },
  VCard: {
    rounded: 'lg',
  },
  VDialog: {
    variant: 'outlined'
  },
}
